<template lang="pug">
  el-dialog(
    :visible.sync="dialogVisible"
    :width="dialogWidth"
    class="custom-dialog-edicao-cadastro"
    top="5vh"
    @close="resetForm"
    title="Editar informações"
    :close-on-click-modal="false"
  )
    .cadastro(v-loading="load")
      .login-cadastro__form
        .login-cadastro__form__group
          .tipo-pessoa
            label(for="tipoPessoa") Tipo
            el-radio-group(v-model="pfPj" size="small")
              el-radio-button(label="Pessoa Física")
              el-radio-button(label="Pessoa Jurídica")
          .box-nome
            .nome
              label(for="nome") Nome <span class="required-asterisk">*</span>
              el-input(v-model="nome" placeholder="Digite seu nome" id="nome" autocomplete="new-password" @blur="validateField('nome')" :class="[validationErrors.nome && 'input-error']")
            .email
              label(for="email") E-mail <span class="required-asterisk">*</span>
              el-input(v-model="emailCadastro" placeholder="Digite seu e-mail" type="email" id="email" autocomplete="new-password" @blur="validateField('emailCadastro')" :class="[validationErrors.emailCadastro && 'input-error']")
          .box-telefone
            .cnpj
              label(for="cpfCnpj") CPF/CNPJ <span class="required-asterisk">*</span>
              el-input(v-model="cpfCnpj" :maxlength="18" placeholder="Digite seu CPF ou CNPJ" id="cpfCnpj" autocomplete="new-password" v-mask="['###.###.###-##', '##.###.###/####-##']" @blur="validateField('cpfCnpj')" :class="[validationErrors.cpfCnpj && 'input-error']")
            .fixo
              label(for="telefone") Telefone
              el-input(v-model="telefone" :maxlength="15" placeholder="Digite seu telefone" id="telefone" autocomplete="new-password" v-mask="['(##) ####-####', '(##) #####-####']")
            .cel
              label(for="celular") Celular <span class="required-asterisk">*</span>
              el-input(v-model="celular" :maxlength="15" placeholder="Digite seu celular" id="celular" autocomplete="new-password" v-mask="['(##) ####-####', '(##) #####-####']" @blur="validateField('celular')" :class="[validationErrors.celular && 'input-error']")
          .box-cidade
            .cep
              label(for="cep") CEP
              el-input(v-model="cep" placeholder="Digite seu CEP" id="cep" autocomplete="new-password" @blur="buscarEndereco" v-mask="'#####-###'")
            .uf
              label(for="uf") UF
              el-select(v-model="uf" placeholder="UF" id="uf" :disabled="true")
                el-option(v-for="estado in estados" :key="estado" :label="estado" :value="estado")
            .cidade
              label(for="cidade") Cidade
              el-input(v-model="cidade" placeholder="Digite sua cidade" id="cidade" autocomplete="new-password" :disabled="true")
          .box-endereco
            .endereco
              label(for="endereco") Endereço
              el-input(v-model="endereco" placeholder="Digite seu endereço" id="endereco" autocomplete="new-password")
            .bairro
              label(for="bairro") Bairro
              el-input(v-model="bairro" placeholder="Digite seu bairro" id="bairro" autocomplete="new-password")
          //.observacao
            label(for="observacao") Observação
            el-input(v-model="observacao" placeholder="Digite uma observação" id="observacao" autocomplete="new-password")
          .box-senha
            .linksite
              label(for="linkSite") Link do Site
              el-input(v-model="linkSite" placeholder="Digite o link do seu site" id="linkSite" autocomplete="new-password")
        .login-cadastro__form__group__button__cadastrar
          el-button(type="primary" @click="cadastrar" :disabled="isButtonDisabled") Confirmar
          el-button(type="text" @click="dialogVisible = false") Cancelar

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'ModalPerfilEdicao',

  data() {
    return {
      currentDialogWidth: this.calculateDialogWidth(),
      load: false,
      nome: '',
      emailCadastro: '',
      senhaCadastro: '',
      confirmarSenha: '',
      telefone: '',
      celular: '',
      cpfCnpj: '',
      cep: '',
      uf: '',
      cidade: '',
      endereco: '',
      bairro: '',
      observacao: '',
      linkSite: '',
      estados: [
        'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
      ],
      validationErrors: {
        nome: false,
        emailCadastro: false,
        cpfCnpj: false,
        celular: false
      },
      pfPj: 'Pessoa Física',
    }
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  computed: {
    ...mapGetters({
      getEdicaoInformacoes: 'modais/getEdicaoInformacoes',
      getUsuarioLogado: 'usuario/user',
    }),
    dialogVisible: {
      get(){
        return this.getEdicaoInformacoes
      },
      set(newValue){
        this.setEdicaoInformacoes(newValue)
      }
    },
    dialogWidth() {
      return this.currentDialogWidth;
    },
    isButtonDisabled() {
      return !this.nome || !this.emailCadastro || !this.cpfCnpj || !this.celular || Object.values(this.validationErrors).some(error => error);
    }
  },

  watch: {
    dialogVisible(){
      if(this.dialogVisible){
        this.nome = this.getUsuarioLogado.nome
        this.emailCadastro = this.getUsuarioLogado.email
        this.telefone = this.getUsuarioLogado.telefone
        this.celular = this.getUsuarioLogado.celular
        this.cpfCnpj = this.getUsuarioLogado.cpf_cnpj
        this.cep = this.getUsuarioLogado.cep
        this.uf = this.getUsuarioLogado.uf
        this.cidade = this.getUsuarioLogado.cidade
        this.endereco = this.getUsuarioLogado.endereco
        this.bairro = this.getUsuarioLogado.bairro
        //this.observacao = ''
        this.linkSite = this.getUsuarioLogado.link_site
        this.pfPj = this.getUsuarioLogado.pf_pj == 'PF' ? 'Pessoa Física' : this.getUsuarioLogado.pfPj == '' ? 'Pessoa Física' : 'Pessoa Jurídica'

        if(this.getUsuarioLogado.telefone) this.maskedTelefone()
        if(this.getUsuarioLogado.celular) this.maskedCelular()
        if(this.getUsuarioLogado.cpf_cnpj) this.maskedCpfCnpj()
        if(this.getUsuarioLogado.cep) this.maskeCep()
      }
    },
    
  },

  methods: {
    ...mapActions({
      cadastrarUsuario: 'auth/cadastrarUsuarioPlataforma',
      alterarCadastro: 'usuario/alterarCadastro',
      getUsuario: 'usuario/getUsuario',
    }),
    ...mapMutations({
      setLoading: 'globais/setLoading',
      setEdicaoInformacoes: 'modais/setEdicaoInformacoes'
    }),
    calculateDialogWidth() {
      return window.innerWidth < 576 ? '90%' : '740px'
    },
    handleResize() {
      this.currentDialogWidth = this.calculateDialogWidth()
    },
    async buscarEndereco() {
      const cepSemMascara = this.cep.replace(/\D/g, "")
      if(cepSemMascara.length === 8 && cepSemMascara != this.getUsuarioLogado.cep){
        this.load = true
        try {
          const response = await fetch(`https://viacep.com.br/ws/${cepSemMascara}/json/`)
          if (!response.ok) {
            this.load = false
            throw new Error("Erro ao buscar endereço.")
          }
          const data = await response.json()
          if (data.erro) {
            this.load = false
            alert("CEP não encontrado.")
            return
          }
          this.uf = data.uf
          this.cidade = data.localidade
          this.endereco = data.logradouro
          this.bairro = data.bairro
          this.load = false
        } catch (error) {
          console.error(error)
          alert("Não foi possível buscar o endereço. Tente novamente.")
          this.load = false
        }
      }
    },
    cadastrar() {
      this.setLoading(true)
      const params = {
        nome: this.nome,
        email: this.emailCadastro,
        telefone: this.telefone,
        celular: this.celular,
        cpfCnpj: this.cpfCnpj,
        cep: this.cep,
        uf: this.uf,
        cidade: this.cidade,
        endereco: this.endereco,
        bairro: this.bairro,
        linkSite: this.linkSite,
        pfPj: this.pfPj == 'Pessoa Física' ? 'PF' : 'PJ',
      }

      this.alterarCadastro(params)
      .then(() => {
        this.setLoading(false)
        this.getUsuario()
        this.$message({
          message: 'Cadastro alterado com sucesso!',
          type: 'success'
        })
        setTimeout(() => {
          this.dialogVisible = false
        }, 3000)
      })
      .catch(err => {
        this.setLoading(false)
        this.$message.error(err.response.data)
      })
    },
    resetForm() {
      this.nome = ''
      this.emailCadastro = ''
      this.telefone = ''
      this.celular = ''
      this.cpfCnpj = ''
      this.cep = ''
      this.uf = ''
      this.cidade = ''
      this.endereco = ''
      this.bairro = ''
      this.observacao = ''
      this.linkSite = ''
      this.validationErrors = {
        nome: false,
        emailCadastro: false,
        cpfCnpj: false,
        celular: false
      }
    },

    maskedCpfCnpj() {
      if (this.cpfCnpj.length == 11) {
        this.cpfCnpj = this.cpfCnpj.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
      } else if (this.cpfCnpj.length > 11) {
        this.cpfCnpj = this.cpfCnpj.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
      }
    },
    maskedTelefone() {
      if (this.telefone.length == 10) {
        this.telefone = this.telefone.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else if (this.telefone.length == 11) {
        this.telefone = this.telefone.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }
    },
    maskedCelular() {
      if (this.celular.length == 10) {
        this.celular = this.celular.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
      } else if (this.celular.length == 11) {
        this.celular = this.celular.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
      }
    },
    maskeCep() {
      if (this.cep.length == 8) {
        this.cep = this.cep.replace(/(\d{5})(\d{3})/, '$1-$2');
      }
    },
    validateField(field) {
      if (field === 'emailCadastro') {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        this.validationErrors.emailCadastro = !emailPattern.test(this.emailCadastro);
      } else {
        this.validationErrors[field] = !this[field];
      }
    }
  }
}
</script>

<style lang="scss">
.custom-dialog-edicao-cadastro {
  background: rgba(0, 0, 0, .6);

  .el-dialog {
    border-radius: 10px;

    .el-dialog__header {
      padding: 20px;
      font-size: 18px;
      font-weight: 600;
      border-bottom: 1px solid #bcb8b8;

      .el-dialog__headerbtn {
        top: 19px;

        i {
          font-size: 30px;
        }
      }
    }

    .el-dialog__body {
      padding: 20px;

      .cadastro {
        .login-cadastro__form {
          .tipo-pessoa{
            display: flex;
            flex-direction: column;
          }
          .box-nome,
          .box-senha,
          .box-telefone,
          .box-cidade {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 10px;

            .nome,
            .email {
              width: 340px;
            }

            .fixo,
            .cel {
              width: 195px;
            }
            .cnpj {
              width: 265px;
            }
            .uf {
              width: 100px;
            }
            .cidade {
              width: 330px;
            }
            .linksite {
              width: 100%;
            }
          }
          .box-endereco {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            margin-top: 10px;
            margin-bottom: 10px;

            .endereco,
            .bairro {
              width: 340px;
            }
          }
          .observacao {
            margin-bottom: 10px;
          }
        }
        .login-cadastro__form__group__button__cadastrar {
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 25px;
        }
      }
    }

    .el-dialog__footer {
      .dialog-footer {
        display: flex;
        justify-content: center;
        gap: 10px;
      }
    }
  }
}

.required-asterisk {
  color: red;
}

.input-error .el-input__inner {
  border-color: #ff4500 !important;
}

@media (max-width: 576px) {
  .custom-dialog-edicao-cadastro {
    .el-dialog__body {
      .cadastro {
        .login-cadastro__form {
          .tipo-pessoa {
            width: 100% !important;
            margin-bottom: 10px;
          }
          .box-nome,
          .box-senha,
          .box-telefone,
          .box-cidade,
          .box-endereco {
            flex-direction: column;

            .nome,
            .email,
            .fixo,
            .cel,
            .cnpj,
            .uf,
            .cep,
            .cidade,
            .endereco,
            .bairro,
            .linksite {
              width: 100% !important;
              margin-bottom: 10px;
            }
          }
          .box-cidade{
            .uf{
              display: flex;
              flex-direction: column;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }
}
</style>